// extracted by mini-css-extract-plugin
export default {"table":"Table_table__ggcFc","accountDetails":"Table_accountDetails__B062t","link":"Table_link__KZUtY"};